import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterPagoNotaCobro from 'views/machine/pagoNotaCobro/filterPagoNotaCobro'; // Importing filter component
import PagoNotaCobro from 'views/machine/pagoNotaCobro/PagoNotaCobro'; // Importing main PagoNotaCobro component
import TablePagoNotaCobro from 'views/machine/pagoNotaCobro/tablePagoNotaCobro'; // Importing table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for Pago Nota Cobro.
 * @extends JetView
 */
export default class pagoNotaCobroView extends JetView {
    /**
     * Configures the UI components for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Button configuration
        const button = {
            margin: 10,
            id: 'buttonPagarNotaCobro', // Button ID
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Pagar Nota Cobro'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event handler
                    },
                },
            ],
        };

        // Left panel configuration
        const left = {
            Width: 250,
            responsiveCell: false,
            height: 1500,
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying theme to toolbar
                    elements: [
                        { view: 'label', label: _('Pago Nota de Cobro') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigation on click
                                },
                            ],
                        },
                    ],
                },
                FilterPagoNotaCobro, // Including filter component
                TablePagoNotaCobro, // Including table component
                toolbar, // Including toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            type: 'wide',
            responsive: true,
            css: 'out',
            cols: [left, { view: 'resizer' }], // Layout configuration
        };
    }
}

// FILE DOCUMENTED
